// extracted by mini-css-extract-plugin
export default {"text":"ESIMListOfCountries_text__dnF1v","country":"ESIMListOfCountries_country__bXUip"};